import { Component, inject } from '@angular/core';
import { PowProgressComponent } from '../../helper/pow-progress/pow-progress.component';
import { PowService, PowSolution } from '../../service/pow.service';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-guest-submission',
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    PowProgressComponent
  ],
  templateUrl: './guest-submission.component.html',
  styleUrl: './guest-submission.component.less'
})
export class GuestSubmissionComponent {
  vrchatUsername = "";

  powService = inject(PowService);

  // Proof of work: the connect button stays disabled until pow is set
  pow: PowSolution | null = null;
  powError = false;

  ngOnInit() {
    this.preparePow();
  }

  async preparePow() {
    this.pow = null;
    this.powError = false;
    try {
      this.pow = await this.powService.solve('patreon');
    } catch (e) {
      console.error('Failed to solve Patreon challenge:', e);
      this.powError = true;
    }
  }

  get patreonOAuthURL() {
    const client_id = "590gN3Yo_MXYGV5MVsHnHS5qfnFwHGVXZH81OVS8u0wkbl3u2cKa3wITmZIM4AAF";
    const redirect_uri = "https://jar.games/patreon";
    const state = {
      action: "guest",
      vrchat_username: this.vrchatUsername,
      pow: this.pow
    };

    return `https://www.patreon.com/oauth2/authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=code&scope=campaigns+identity.memberships+identity+identity%5Bemail%5D&state=`+encodeURIComponent(JSON.stringify(state));
  }

  authenticate() {
    if (!this.pow) {
      if (this.powError) this.preparePow();
      return;
    }
    window.location.href = this.patreonOAuthURL;
  }
}
